import React, { memo } from "react";
import { Box, Chip, Stack } from "@mui/material";
import Marquee from "react-fast-marquee";
import { BsDot } from "react-icons/bs";
import logos from "./Logos"; // Import from the static file

const ChipScroll = memo(() => {
  return (
    <Box
      sx={{
        width: "100%", // Ensure it fits within parent
        overflow: "hidden", // Prevent chips from overflowing
        position: "relative", // Ensure alignment inside the parent
        height: "80px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        // backgroundColor: "rgb(227, 255, 101)",
        backgroundColor: "rgb(238 245 252)",
      }}
    >
      <Marquee pauseOnHover={true} speed={50}
        style={{
          maskImage: 'linear-gradient(to right, transparent, black 10% 90%, transparent)',
        }}
      >
        {logos.map((logo, index) => (
          <Stack
            key={index}
            direction="row"
            alignItems="center"
            spacing={0} // Adds spacing between Chip and Dot
          >
            <Chip
              label={logo.img}
              variant="outlined"
              sx={{
                marginLeft: "12px",
                // backgroundColor: "rgb(227, 255, 101)",
                backgroundColor: "rgb(238 245 252)",
                height: "48px",
                fontSize: "16px",
                borderRadius: "8px",
                border: "none",
              }}
            />
            <BsDot size={30} color="black" />
          </Stack>
        ))}
      </Marquee>
    </Box>
  );
});

export default ChipScroll;
